import { Image } from "react-bootstrap";
import defaultUser from "../assets/img/avatars/default-user.png";
import SelectColumnFilter from "../utils/SelectColumnFilter";

const getClientData = ({ t, isAdminOrTenant = false }) => {
  const clientColumns = [
    {
      Header: "",
      accessor: "image",
      Cell: ({ row }) => (
        <Image
          className="avatar rounded-circle"
          src={
            row.original.image && row.original.image.imagePath
              ? `${process.env.REACT_APP_POS2CLOUD_IMAGE_URL}${row.original?.image?.imagePath}`
              : defaultUser
          }
          alt=""
        />
      ),
      sortable: false,
      Filter: () => null,
      canRenderFilter: false,
    },
    {
      Header: "ID",
      accessor: "id",
      sortable: true,
      canRenderFilter: false,
    },
    {
      Header: t("crm.fullName"),
      accessor: "fullName",
      sortable: true,
      canRenderFilter: true,
    },
    {
      Header: t("crm.company"),
      accessor: "company",
      Cell: ({ row }) => <>{row.original?.company ?? "N/A"}</>,
      sortable: true,
      canRenderFilter: true,
    },
    {
      Header: t("crm.email"),
      accessor: "email",
      sortable: true,
      canRenderFilter: true,
    },
    {
      Header: t("crm.accountId"),
      accessor: "portfolio.portfolioId",
      sortable: true,
      canRenderFilter: true,
    },
  ];

  // ✅ Add Tenant column only for admin or tenant roles
  if (isAdminOrTenant) {
    clientColumns.push({
      Header: "Tenant",
      accessor: "tenantLogo",
      Cell: ({ row }) => (
        <Image
          className="avatar rounded-circle"
          src={
            row.original.tenantLogo
              ? `${process.env.REACT_APP_POS2CLOUD_IMAGE_URL}${row.original?.tenantLogo}`
              : defaultUser
          }
          alt=""
        />
      ),
      sortable: false,
      Filter: () => null,
      canRenderFilter: false,
    });
  }

  return { clientColumns };
};

export default getClientData;
